module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "pa-3"
  }, [_vm._v("\n    " + _vm._s(_vm.customDescription) + "\n  ")]), _vm._v(" "), _c('ds-schedule-frequency-year', {
    attrs: {
      "day": _vm.day,
      "schedule": _vm.schedule
    }
  }), _vm._v(" "), _c('ds-schedule-frequency-month', {
    attrs: {
      "schedule": _vm.schedule
    }
  }), _vm._v(" "), _c('ds-schedule-frequency-week', {
    attrs: {
      "schedule": _vm.schedule
    }
  }), _vm._v(" "), _c('ds-schedule-frequency-day-of-week', {
    attrs: {
      "schedule": _vm.schedule
    }
  }), _vm._v(" "), _c('ds-schedule-frequency-day', {
    attrs: {
      "schedule": _vm.schedule
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e254a5ec","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ScheduleTypeCustom.vue
// module id = 189
// module chunks = 0